// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ERC20Wei } from './conversions'
import { yupErc20WeiRequired, yupEthAddrRequired } from './Enums'
import { EthAddr, StringTypeEnum, toFieldMetaData } from './SchemaTypes'
import * as yup from 'yup'

export const LytExchangeRateCheckSchema = yup.object({
  lytPoolAddr: yupEthAddrRequired
    .label('Vault Address')
    .required()
    .meta(
      toFieldMetaData({
        propName: 'lytPoolAddr',
        description: 'Address of Vault ',
        stringType: StringTypeEnum.ETH_ADDR,
      })
    ),

  exchangeRate: yup
    .number()
    .required()
    .default(1)
    .label('Exchange Rate')
    .meta(toFieldMetaData({ propName: 'exchangeRate', stringType: StringTypeEnum.EXCHANGE_RATE })),

  expectedBalance: yupErc20WeiRequired
    .label('Expected Balance')
    .required()
    .meta(toFieldMetaData({ propName: 'expectedBalance' })),
  expectedExchangeRate: yup
    .number()
    .required()
    .default(1)
    .label('ExpectedExchange Rate')
    .meta(toFieldMetaData({ propName: 'expectedExchangeRate', stringType: StringTypeEnum.EXCHANGE_RATE })),

  reserveAssets: yupErc20WeiRequired
    .label('Reserve Pool Assets')
    .required()
    .meta(toFieldMetaData({ propName: 'reserveAssets', stringType: StringTypeEnum.STABLE_COINS })),

  assetDelta: yupErc20WeiRequired
    .label('Asset Delta')
    .required()
    .meta(toFieldMetaData({ propName: 'assetDelta', stringType: StringTypeEnum.STABLE_COINS })),
  outstandingLytPoolShares: yupErc20WeiRequired
    .label('Outstanding Lyt Pool Shares')
    .required()
    .meta(toFieldMetaData({ propName: 'outstandingLytPoolShares', stringType: StringTypeEnum.STABLE_COINS })),
  isReconciled: yup
    .boolean()
    .required()
    .default(false)
    .label('Is Reconciled')
    .meta(toFieldMetaData({ propName: 'isReconciled' })),
  liquidityBufferAssets: yupErc20WeiRequired
    .label('liquidityBufferAssets')
    .required()
    .meta(toFieldMetaData({ propName: 'liquidityBufferAssets', stringType: StringTypeEnum.STABLE_COINS })),
  lytPoolAsset: yupErc20WeiRequired
    .label('lytPoolAsset')
    .required()
    .meta(toFieldMetaData({ propName: 'lytPoolAsset', stringType: StringTypeEnum.STABLE_COINS })),
  totalAssets: yupErc20WeiRequired
    .label('Total Reserve Assets')
    .required()
    .meta(toFieldMetaData({ propName: 'totalAssets', stringType: StringTypeEnum.STABLE_COINS })),
})
export interface LytExchangeRateCheckCTO {
  lytPoolAddr: EthAddr
  exchangeRate: ERC20Wei
  expectedBalance: ERC20Wei
  expectedExchangeRate: ERC20Wei
  reserveAssets: ERC20Wei

  assetDelta: ERC20Wei

  outstandingLytPoolShares: ERC20Wei
  isReconciled: boolean

  liquidityBufferAssets: ERC20Wei
  lytPoolAsset: ERC20Wei
  totalAssets: ERC20Wei
}
